import componentService, { ComponentKeys, type Component} from "../../../../core/services/componentService/component-service";


let iconsSpriteIDMapping: spriteIDIconMapping;
const iconSize: number = 112;

interface spriteIDIconMapping {
    [id: string]: Component[ComponentKeys.SpriteID];
}

export interface Position {
    x: number;
    y: number;
}

function getNativeIconsSpriteIDMapping(): spriteIDIconMapping {
    if (iconsSpriteIDMapping) {
        return iconsSpriteIDMapping;
    }
    const iconsDataArr: Component[] = componentService.getAllComponents();
    let data: spriteIDIconMapping = {};
    iconsDataArr.forEach((iconData: Component) => (data[iconData[ComponentKeys.ImageID]] = iconData[ComponentKeys.SpriteID]));

    iconsSpriteIDMapping = data;
    return data;
}

function getAlphabetValue(letter: String): number {
    return letter.charCodeAt(0) - 64;
}

export function useIconSpritePosition(name: string, spriteIdProp?: string): Position {
    let spriteID: string = spriteIdProp;
    if (!spriteIdProp) {
        const iconsData = getNativeIconsSpriteIDMapping();
        spriteID = iconsData[name];
    }

    if (!spriteID) {
        console.error("Can't found icon position, because name and spriteID are no passed");
        return null;
    }

    const columnNumber = getAlphabetValue(spriteID[0]);
    const rowNumber = Number(spriteID.slice(1));
    return {
        x: ((columnNumber - 1) * iconSize) / 2,
        y: ((rowNumber - 1) * iconSize) / 2
    };
}

